import { useEffect, useState } from 'react';

// Returns true when the viewport is narrower than `breakpoint` (default 768px,
// matching Tailwind's `md`). Updates on resize and on orientation changes.
export default function useIsMobile(breakpoint = 768) {
  const get = () =>
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false;

  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, [breakpoint]);

  return isMobile;
}
